import { render, staticRenderFns } from "./gc-popup-sales-order-update-item.vue?vue&type=template&id=252e0010&scoped=true"
import script from "./gc-popup-sales-order-update-item.vue?vue&type=script&lang=js"
export * from "./gc-popup-sales-order-update-item.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-sales-order-update-item.vue?vue&type=style&index=0&id=252e0010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252e0010",
  null
  
)

export default component.exports